export const DECISION_COLORS: Record<string, string> = {
  shortlist: "#22c55e",
  consider: "#f59e0b",
  reject: "#ef4444",
};

export const DECISION_LABELS: Record<string, string> = {
  shortlist: "Shortlist",
  consider: "A considerer",
  reject: "Rejete",
};

export const MODE_LABELS: Record<string, string> = {
  anonymized_gemini: "Gemini",
  infomaniak_dual: "Dual Infomaniak",
  gemini_all: "Gemini All",
  hybrid_infomaniak_gemini: "Hybrid",
  infomaniak_all: "Infomaniak All",
};

export const RATING_COLORS: Record<string, string> = {
  A: "bg-success text-success-foreground",
  B: "bg-warning text-warning-foreground",
  C: "bg-destructive text-destructive-foreground",
};

export const MODEL_COLORS = ["#6366f1", "#06b6d4", "#f97316", "#8b5cf6"];

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateShort = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const ensureArray = (item: any): any[] => {
  if (Array.isArray(item)) return item;
  if (item === null || item === undefined) return [];
  if (typeof item === "string") return [item];
  return [];
};
